import React from 'react';
import Page, { Grid, GridColumn } from '@atlaskit/page';
import { Control, DeepMap, FieldError } from 'react-hook-form';
import iProductServiceType from '../../../types/contactCompany/iProductServiceType';
import InputWithController from '../../../shared/form/hookForms/InputWithController';

const ServiceTypeModalBody = ({
  control,
  errors,
  onChange,
  target,
}: {
  //    eslint-disable-next-line
  control: Control<Record<string, any>>;
  //    eslint-disable-next-line
  onChange: (name: string, value: any, config?: Object) => void;
  //    eslint-disable-next-line
  errors?: DeepMap<Record<string, any>, FieldError>;
  target?: iProductServiceType;
}) => {
  return (
    <Page>
      <Grid layout={'fluid'}>
        <GridColumn medium={6}>
          <InputWithController
            name={'name'}
            label={'Name'}
            defaultValue={target?.name}
            control={control}
            onChange={onChange}
            errors={errors}
            isRequired
            testId={'service-type-modal-name'}
          />
        </GridColumn>
        <GridColumn medium={6}>
          <InputWithController
            name={'description'}
            label={'Description'}
            defaultValue={target?.description}
            control={control}
            onChange={onChange}
            errors={errors}
            isRequired={false}
            testId={'service-type-modal-description'}
          />
        </GridColumn>
      </Grid>
    </Page>
  );
};

export default ServiceTypeModalBody;
